import React, { useState, useRef, useEffect, memo } from 'react';
import * as THREE from 'three';
import { TubeCurve } from '../shape/Spline';
import { Point } from "../shape/Point";
import { Points } from "../shape/Point";
import { toast, ToastContainer } from 'react-toastify';
//import { Geometry, Base, Subtraction, Addition } from '@react-three/csg'
import { SUBTRACTION, Brush, Evaluator } from 'three-bvh-csg';
import * as BufferGeometryUtils from 'three/addons/utils/BufferGeometryUtils.js';
import { TextGeometry } from 'three/addons/geometries/TextGeometry.js';
import { FontLoader } from 'three/addons/loaders/FontLoader.js';
import helvetiker from 'three/examples/fonts/helvetiker_regular.typeface.json';
import { drawIntersectionPoints,getContours } from './utils';
import { adapterHeight } from './mAssembleAk';
import {
  offsetCurve, 
  offsetCurveMm, 
  sortPoints, 
  calculateCurveCenter, 
  calculateIntersectionPoints, 
  calcCentroid,
  getBottomPoints,
  alignSeamPoints,
  makeCurveClockwise,
  createLoftSurfaceFrom2Curves,
  createLoftSurfaceFrom2CurvesSmooth,
  createLoftSurfaceFromCurves,
  getContourPointsCircumAll,
  offsetPointsNormalBufferGeometry,
  calcWrapPointsLowerUpperSurface,
  mergeLowerUpperPoints,
  createBottmCapSurface,
  calculateTweenCurve,
  calculateCurveLength,
  smoothGeom,
  findClosestPointOnPoints,
  removeOutliersThreePoints
} from '../shape/utils';

import {
  translateBufferGeometry
} from '../shape/utils/affine';

import {
  calcCenter
} from '../shape/utils/points';

import {
  makeCircleGetPoints
} from '../shape/utils/curve';

import {
  projectPointsToMesh
} from '../shape/utils/intersection';
import { Cylinder } from '@react-three/drei';


const getCheckHole = (center, radius, holeDepth, stumpLength, flexAngle) => {
  // check hole ///////////////////////////////////////////////
  var center = new THREE.Vector3(center[0], center[1], center[2]);

  const checkHoleGeometry = new THREE.CylinderGeometry(radius, radius, holeDepth, 32);
  checkHoleGeometry.rotateZ(-Math.PI * 0.25);
  checkHoleGeometry.rotateY(Math.PI * 0.25);
  checkHoleGeometry.translate(center.x-holeDepth/2*Math.cos(Math.PI*0.25)*Math.cos(Math.PI*0.25), -stumpLength+10, center.z+holeDepth/2*Math.cos(Math.PI*0.25)*Math.cos(Math.PI*0.25));
  //checkHoleGeometry.translate(center.x-20, -stumpLength+70, center.z+stumpLength * Math.tan(Math.PI*5/180));

  // Align for initial flexion angle
  checkHoleGeometry.rotateX(-flexAngle /180 * Math.PI);

  return checkHoleGeometry
}

/**
 * make a tear drop shape
 * @param {*} centroidBaseshape 
 * @param {*} offsetY 
 * @returns THREE.Geometry
 */
function getTearDrop(centroidBaseshape, offsetY) {
  var center = new THREE.Vector3(centroidBaseshape.x, centroidBaseshape.y+offsetY, centroidBaseshape.z);

  const shape = new THREE.Shape();
  //shape.moveTo(0, 0);
  //shape.quadraticCurveTo(5, 10, 10, 0);
  //shape.quadraticCurveTo(0.5, 1, 0, 1);
  //shape.closePath();
  const r = 13

  shape.moveTo(0, 0);
  shape.arc(r/2, 30, r, 1.2*Math.PI, -0.2*Math.PI, true);
  shape.lineTo(r/2, 0);
  shape.closePath();
  shape.arcLengthDivisions = 5;

  const extrudeSettings = {
    steps: 1,
    depth: -200,
  };
  var geom = new THREE.ExtrudeGeometry( shape, extrudeSettings );
  geom.rotateY(Math.PI * 0.5);
  geom.rotateZ(Math.PI);
  geom.translate(center.x, center.y, center.z);

  return geom
}

function deleteInnerTrimmingBug(upperSurface) {
  let positions = upperSurface.attributes.position.array;
  //let indices = upperSurface.index.array; // no need for non-index buffergeometry

  let newPositions = [];
  //let newIndices = [];
  let mapping = [];
  let j = 0;
  let minX = 0
  let cnt = 0

  for(let i = 0; i < positions.length; i += 3) {
    minX = Math.min(minX, positions[i])
  }

  if (upperSurface.index === null) {
    // console.log("This BufferGeometry is non-indexed.");
  } else {
    console.log("This BufferGeometry is indexed.");
  }

  ///*
  // x < 0の頂点を削除
  // 非インデックス化された BufferGeometry では、3つの連続する頂点が1つの面（三角形）を形成します。それぞれの頂点は3つの座標情報（x, y, z）を持つため、1つの面を表現するためには配列の9つの要素（= 3頂点 × 3座標）が必要となります。
  const offset = minX + 0.001;
  for(let i = 0; i < positions.length; i += 9) {
    //console.log(positions[189405])
    //if (i >= positions.length-90) {
    if(positions[i] <= offset && positions[i+3] <= offset && positions[i+6] <= offset) {
      cnt += 1
    } else {
      newPositions.push(
        positions[i], positions[i+1], positions[i+2],
        positions[i+3], positions[i+4], positions[i+5],
        positions[i+6], positions[i+7], positions[i+8]
      );
    }
  }

  // no need for non-index buffergeometry
  // // 削除した頂点を参照する面を削除
  // for(let i = 0; i < indices.length; i += 3) {
  //   if(mapping[indices[i]] !== undefined &&
  //     mapping[indices[i+1]] !== undefined &&
  //     mapping[indices[i+2]] !== undefined) {
  //     newIndices.push(mapping[indices[i]], mapping[indices[i+1]], mapping[indices[i+2]]);
  //   }
  // }
  //upperSurface.toNonIndexed()
  upperSurface.setAttribute('position', new THREE.Float32BufferAttribute(newPositions, 3));
  
  //upperSurface.setIndex(newIndices);  // no need for non-index buffergeometry
  //upperSurface.computeVertexNormals();


  if (upperSurface.index === null) {
    // console.log("This BufferGeometry is non-indexed.");
  } else {
    console.log("This BufferGeometry is indexed.");
  }

  return upperSurface
}



const MOutputAkFd = memo(({
  type, // TestSocket or Final
  side,
  stumpLength,
  centroidBaseshape,
  apDiameter,
  crossPoints,
  adductAngle,
  flexAngle,
  oriLowerSurface,
  oriUpperSurface,
  socketThickness,
  radiusCheckHole,
  intervalCheckHole,
  stepFlow,
  splitAdjust,
  assembleAdapter,
  assembleSocketMl,
  assembleSocketAp,
  assembleSocketSi,
  assembleFlexionExtension,
  assembleAdductionAbduction,
  assembleSocketRotation,
  engraving,
  callback,
  color,
  colorHigh,
  colorSub
}) => {
  const ref        = useRef();
  const objects = [];
  const objectsInner = [];
  const objectsSub = [];
  const objectsSub2 = [];
  const objectsHole = [];
  const sideHoleGeometries = [];
  var key = 0;
  var geom = null;

  const crossInterval = 15; // 50;
  const div = 60; // 60, 80
  const segmentsWidth = div; // 150
  const segmentsHeight = 100; //500
  const splitHeight = stumpLength*2/3;
  const gapInnerOuterBottom = -26
  const rotationCenter = new THREE.Vector3(centroidBaseshape.x, -stumpLength+gapInnerOuterBottom-12, centroidBaseshape.z);
  const angleStepInitial = 10;
  const angleStep = 10;
  const sideHolePosition = -50;
  const holeDepth = 200;
  const defaultFourHoleDepth = 100;
  const fourHoleDepth = 100;
  const radiusInnerFourHole = 3.2;
  const radiusOuterFourHole = 8.5;
  const offsetBoolean = 1; // this is for escape from the error of boolean operation
  const offsetOuterFourHole = 12; //5;
  const intervalFourHole = 18;
  const radiusCounterHole = 19;
  const radiusIschium = 15;
  const counterHoleDepth = 10;
  const offsetCounterHole = 3;
  const reinforceEdgeWidth = 25; // 15
  const reinforceEdgeHeight = 2;
  const offsetAddapter = (type=='TestSocket') ? 0 : -adapterHeight[assembleAdapter]

  const material = new THREE.MeshLambertMaterial({color: color, transparent: true, opacity: 0.1, side: THREE.DoubleSide});
  const materialInner = new THREE.MeshBasicMaterial({ color: colorSub, transparent: true, opacity: 0.6, side: THREE.DoubleSide });
  const materialHole = new THREE.MeshBasicMaterial({ color: color, transparent: true, opacity: 0.6, side: THREE.DoubleSide });
  const materialText = new THREE.MeshBasicMaterial({ color: 'red', transparent: true, opacity: 0.6, side: THREE.DoubleSide, wireframe: true});

  const loader = new FontLoader();

  console.log("MOutputAkFd");

  let lowerSurface = oriLowerSurface.clone();
  let upperSurface = oriUpperSurface.clone();

  // calc bottom center
  const bottomCenter = calcCenter(crossPoints[0])

  // 4 hole outer ///////////////////////////////////////////////
  var center = new THREE.Vector3(centroidBaseshape.x-assembleSocketMl, -stumpLength+gapInnerOuterBottom+offsetOuterFourHole-assembleSocketSi+offsetAddapter, centroidBaseshape.z+assembleSocketAp);

  // calc four hole cylinder height
  //// 1. make circle and get points on the circle
  const center0 = new THREE.Vector3(center.x+intervalFourHole, center.y, center.z+intervalFourHole);
  const center1 = new THREE.Vector3(center.x+intervalFourHole, center.y, center.z-intervalFourHole);
  const center2 = new THREE.Vector3(center.x-intervalFourHole, center.y, center.z+intervalFourHole);
  const center3 = new THREE.Vector3(center.x-intervalFourHole, center.y, center.z-intervalFourHole);

  const points0 = makeCircleGetPoints(center0, radiusOuterFourHole, 10);
  const points1 = makeCircleGetPoints(center1, radiusOuterFourHole, 10);
  const points2 = makeCircleGetPoints(center2, radiusOuterFourHole, 10);
  const points3 = makeCircleGetPoints(center3, radiusOuterFourHole, 10);
  
  //// 2. project points on the circle to the lowerSurface with raycaster
  const tempLowerSurfaceMesh = new THREE.Mesh( lowerSurface, materialInner ) ;

  const projectedPoints0 = projectPointsToMesh(points0, tempLowerSurfaceMesh);
  const projectedPoints1 = projectPointsToMesh(points1, tempLowerSurfaceMesh);
  const projectedPoints2 = projectPointsToMesh(points2, tempLowerSurfaceMesh);
  const projectedPoints3 = projectPointsToMesh(points3, tempLowerSurfaceMesh);

  //// 3. calc height
  const calcHeight = (points, center) => {
    const maxY = Math.max(...points.map((point) => point.y));
    const offset = 1.2; // just in case
    return offset * (maxY - center.y);
  }

  const fourHoleDepth0 = (projectedPoints0.length > 0) ? calcHeight(projectedPoints0, center0) : defaultFourHoleDepth;
  const fourHoleDepth1 = (projectedPoints1.length > 0) ? calcHeight(projectedPoints1, center1) : defaultFourHoleDepth;
  const fourHoleDepth2 = (projectedPoints2.length > 0) ? calcHeight(projectedPoints2, center2) : defaultFourHoleDepth;
  const fourHoleDepth3 = (projectedPoints3.length > 0) ? calcHeight(projectedPoints3, center3) : defaultFourHoleDepth;

  const outerFourHoleGeometry0 = new THREE.CylinderGeometry(radiusOuterFourHole, radiusOuterFourHole, fourHoleDepth0, 32);
  const outerFourHoleGeometry1 = new THREE.CylinderGeometry(radiusOuterFourHole, radiusOuterFourHole, fourHoleDepth1, 32);
  const outerFourHoleGeometry2 = new THREE.CylinderGeometry(radiusOuterFourHole, radiusOuterFourHole, fourHoleDepth2, 32);
  const outerFourHoleGeometry3 = new THREE.CylinderGeometry(radiusOuterFourHole, radiusOuterFourHole, fourHoleDepth3, 32);
  outerFourHoleGeometry0.translate(center0.x, center0.y+fourHoleDepth0/2, center0.z);
  outerFourHoleGeometry1.translate(center1.x, center1.y+fourHoleDepth1/2, center1.z);
  outerFourHoleGeometry2.translate(center2.x, center2.y+fourHoleDepth2/2, center2.z);
  outerFourHoleGeometry3.translate(center3.x, center3.y+fourHoleDepth3/2, center3.z);

  const outerFourHoleMeshs = [];
  outerFourHoleMeshs.push(new THREE.Mesh(outerFourHoleGeometry0, materialHole));
  outerFourHoleMeshs.push(new THREE.Mesh(outerFourHoleGeometry1, materialHole));
  outerFourHoleMeshs.push(new THREE.Mesh(outerFourHoleGeometry2, materialHole));
  outerFourHoleMeshs.push(new THREE.Mesh(outerFourHoleGeometry3, materialHole));
  
  objectsHole.push(
    <primitive key={key} object={outerFourHoleMeshs[0]} />
  );
  key += 1;
  objectsHole.push(
    <primitive key={key} object={outerFourHoleMeshs[1]} />
  );
  key += 1;
  objectsHole.push(
    <primitive key={key} object={outerFourHoleMeshs[2]} />
  );
  key += 1;
  objectsHole.push(
    <primitive key={key} object={outerFourHoleMeshs[3]} />
  );
  key += 1;
  /////////////////////////////////////////////////////////

  // 4 hole inner ///////////////////////////////////////////////
  var center = new THREE.Vector3(centroidBaseshape.x-assembleSocketMl, -stumpLength+gapInnerOuterBottom-offsetBoolean-assembleSocketSi+offsetAddapter, centroidBaseshape.z+assembleSocketAp);
  const innerFourHoleDepth0 = 1.2*fourHoleDepth0 + offsetOuterFourHole; // 1.2 is to escape from the error of boolean operation
  const innerFourHoleDepth1 = 1.2*fourHoleDepth1 + offsetOuterFourHole;
  const innerFourHoleDepth2 = 1.2*fourHoleDepth2 + offsetOuterFourHole;
  const innerFourHoleDepth3 = 1.2*fourHoleDepth3 + offsetOuterFourHole;

  const fourHoleGeometry0 = new THREE.CylinderGeometry(radiusInnerFourHole, radiusInnerFourHole, innerFourHoleDepth0, 32);
  const fourHoleGeometry1 = new THREE.CylinderGeometry(radiusInnerFourHole, radiusInnerFourHole, innerFourHoleDepth1, 32);
  const fourHoleGeometry2 = new THREE.CylinderGeometry(radiusInnerFourHole, radiusInnerFourHole, innerFourHoleDepth2, 32);
  const fourHoleGeometry3 = new THREE.CylinderGeometry(radiusInnerFourHole, radiusInnerFourHole, innerFourHoleDepth3, 32);
  fourHoleGeometry0.translate(center0.x, center.y+innerFourHoleDepth0/2, center0.z);
  fourHoleGeometry1.translate(center1.x, center.y+innerFourHoleDepth1/2, center1.z);
  fourHoleGeometry2.translate(center2.x, center.y+innerFourHoleDepth2/2, center2.z);
  fourHoleGeometry3.translate(center3.x, center.y+innerFourHoleDepth3/2, center3.z);

  const fourHoleMesh0 = new THREE.Mesh( fourHoleGeometry0, materialHole );
  const fourHoleMesh1 = new THREE.Mesh( fourHoleGeometry1, materialHole ) ;
  const fourHoleMesh2 = new THREE.Mesh( fourHoleGeometry2, materialHole ) ;
  const fourHoleMesh3 = new THREE.Mesh( fourHoleGeometry3, materialHole ) ;
  objectsHole.push(
    <primitive key={key} object={fourHoleMesh0} />
  );
  key += 1;
  objectsHole.push(
    <primitive key={key} object={fourHoleMesh1} />
  );
  key += 1;
  objectsHole.push(
    <primitive key={key} object={fourHoleMesh2} />
  );
  key += 1;
  objectsHole.push(
    <primitive key={key} object={fourHoleMesh3} />
  );
  key += 1;
  /////////////////////////////////////////////////////////

  // Checkhole //////////////////////////////////////////////////////////
  const checkHoleGeometry = getCheckHole(
    [centroidBaseshape.x, -stumpLength+gapInnerOuterBottom, centroidBaseshape.z],
    radiusCheckHole,
    holeDepth,
    stumpLength,
    flexAngle
  )

  const checkHoleMesh = new THREE.Mesh( checkHoleGeometry, materialHole ) ;
  
  objectsHole.push(
    <primitive key={key} object={checkHoleMesh} />
  );
  key += 1;
  ////////////////////////////////////////////////////////////////////////

  // counter for female pyramid adapter /////////////////////////
  const counterHoleGeometry = new THREE.CylinderGeometry(radiusCounterHole, radiusCounterHole, counterHoleDepth, 32);
  counterHoleGeometry.translate(center.x, center.y-counterHoleDepth/2+offsetCounterHole, center.z);
  const counterHoleMesh = new THREE.Mesh( counterHoleGeometry, materialHole ) ;

  objectsHole.push(
    <primitive key={key} object={counterHoleMesh} />
  );
  key += 1;
  //////////////////////////////////////////////////////////////////////

  // engraving /////////////////////////
  let engravingGeometry = null;
  if (engraving != -1) {
    const helvetikerRegular = loader.parse(helvetiker)
    engravingGeometry = new TextGeometry(engraving.toString(), {
      font: helvetikerRegular,
      size: 12,
      height: 1,
      //depth: 10,
      curveSegments: 2,
      bevelEnabled: false, // bevel で面取りができる
      bevelThickness: 0.1, // 押し出し方向の面取り量（depth の外側に追加）
      bevelSize: 0.1, // 面内方向の面取り量
      bevelOffset: 0,
      bevelSegments: 10 // 大きくすると丸くなる
    });
    engravingGeometry.center();

    // rotation, to make it easier to calaulate vertex positions. Move positions as attibutes.position.array.

    // translation, to make it easier to calaulate vertex positions. Move positions as attibutes.position.array.
    for (let i=0; i<engravingGeometry.attributes.position.array.length; i+=3) {
      // rotateing 180 degree around x asis
      engravingGeometry.attributes.position.array[i] *= -1;
      // transolation
      engravingGeometry.attributes.position.array[i] += center.x;
      engravingGeometry.attributes.position.array[i+1] += center.y+50;
      engravingGeometry.attributes.position.array[i+2] += center.z-75;
    }

    let countMinZ = 0;
    let countMaxZ = 0;
    const bboxx = engravingGeometry.boundingBox;
    const minZ = bboxx.min.z;
    const maxZ = bboxx.max.z;
    for (let i=0; i<engravingGeometry.attributes.position.array.length; i+=3) {
      if (engravingGeometry.attributes.position.array[i+2] == minZ) {
        countMinZ += 1;
      }
      else if (engravingGeometry.attributes.position.array[i+2] == maxZ) {
        countMaxZ += 1;
      }
      else {
        console.log(engravingGeometry.attributes.position.array[i+2])
      }
    }

    console.log(engravingGeometry)

    const engravingMesh = new THREE.Mesh( engravingGeometry, materialText);
    objectsHole.push(
      <primitive key={key} object={engravingMesh} />
    )
    key += 1;
  }
  ///////////////////////////////////////////////////////////////



  // (only TS) tear drop hole ///////////////////////////////////////////////
  const nSideHole = Math.floor((stumpLength+sideHolePosition) / intervalCheckHole);

  for (let i = 0; i < nSideHole; i++) {
    let sideHoleGeometry = null;
    if (false) { // cicle hole
      sideHoleGeometry = new THREE.CylinderGeometry(radiusCheckHole, radiusCheckHole, holeDepth, 32);
      sideHoleGeometry.rotateX(Math.PI * 0.5);
      sideHoleGeometry.rotateY(Math.PI * 0.5);
      sideHoleGeometry.translate(center.x+holeDepth/2, sideHolePosition-i*intervalCheckHole, center.z);
    } else { // tear drop hole
      sideHoleGeometry = getTearDrop(centroidBaseshape, sideHolePosition-i*intervalCheckHole)
    }

    // Judge if geometry is indexed or non-indexed
    if (sideHoleGeometry.index === null) {
      sideHoleGeometry = BufferGeometryUtils.mergeVertices(sideHoleGeometry); // this is to convert non-indexed geometry to indexed geometry
    }

    // flip normal
    const faceIndices = sideHoleGeometry.index;
    for (let i = 0; i < faceIndices.array.length; i += 3) {
      const tmp = faceIndices.array[i];
      faceIndices.array[i] = faceIndices.array[i + 2];
      faceIndices.array[i + 2] = tmp;
    }
    sideHoleGeometry.setIndex(faceIndices);
    sideHoleGeometry.index.needsUpdate = true;


    // Align for initial flexion angle
    sideHoleGeometry.rotateX(-flexAngle /180 * Math.PI);

    sideHoleGeometries.push(sideHoleGeometry);
    const sideHoleMesh = new THREE.Mesh( sideHoleGeometry, materialHole ) ;

    if ( type=='TestSocket' ) {
      objectsHole.push(
        <primitive key={key} object={sideHoleMesh} />
      );
      key += 1;
    }
  }


  // bottom curve ///////////////////////////////////////////////
  const bottomSurfaceCenter = new THREE.Vector3(centroidBaseshape.x, -stumpLength+gapInnerOuterBottom, centroidBaseshape.z);
  var bottomPoints = getBottomPoints(bottomSurfaceCenter);
  // move bottom curve with socket alignment
  bottomPoints = bottomPoints.map((point) => new THREE.Vector3(point.x-assembleSocketMl, point.y-assembleSocketSi+offsetAddapter, point.z+assembleSocketAp));

  // shift bottomPoints by 5points to align the seam of the bottom surface and the upper surface
  bottomPoints = bottomPoints.slice(5, bottomPoints.length).concat(bottomPoints.slice(0, 5));
  bottomPoints.push(bottomPoints[0]);
  
  // objectsSub.push(<TubeCurve 
  //   key={key} 
  //   vpoints={bottomPoints} 
  //   radius={0.5}
  //   color={colorHigh}
  //   />
  // );
  // key += 1;

  /////////////////////////////////////////////////////////////////
  

  upperSurface = deleteInnerTrimmingBug(upperSurface.clone());

  // setup base shape
  upperSurface = BufferGeometryUtils.mergeVertices(upperSurface)
  const upperSurfaceMesh = new THREE.Mesh( upperSurface, materialInner ) ;
  const lowerSurfaceMesh = new THREE.Mesh( lowerSurface, materialInner ) ;
  ///////////////////////////////////////////////

  try {
    // Inner surface ///////////////////////////////////////////////
    // lower and upper warp points
    var [innerLowerWarpPointsAll, innerUpperWarpPointsAll] = calcWrapPointsLowerUpperSurface(
                                                              lowerSurfaceMesh, 
                                                              upperSurfaceMesh, 
                                                              bottomCenter, 
                                                              centroidBaseshape, 
                                                              adductAngle, 
                                                              flexAngle, 
                                                              angleStepInitial,
                                                              );
        
    // Error handling, 前後の要素を比較して、yの値が1以上小さいものを削除(for upper warp points)
    // for (let i=0; i<innerUpperWarpPointsAll.length; i++) {
    //   innerUpperWarpPointsAll[i] = innerUpperWarpPointsAll[i].filter((vector, index, array) => {
    //     if (index === 0 || index === array.length - 1) {
    //       return true; // 配列の最初と最後の要素は保持
    //     }
    //     const nextVector = array[index + 1];
    //     // calc distance between vector and nextVector
    //     const dist = vector.distanceTo(nextVector);
        
    //     return dist < 0.5;
    //     //return nextVector.y - vector.y <= -0.5;
    //     //return Math.abs(nextVector.x - vector.x) <= 3;
    //   });
    // }

    // for (let i=0; i<innerUpperWarpPointsAll.length; i++) {
    //   objectsSub.push(<TubeCurve
    //     key={key}
    //     vpoints={innerUpperWarpPointsAll[i]}
    //     radius={0.5}
    //     color={'white'}
    //   />
    //   );
    //   key += 1;
    // }

    // for (let i=0; i<innerLowerWarpPointsAll.length; i++) {
    //   objectsSub.push(<TubeCurve
    //     key={key}
    //     vpoints={innerLowerWarpPointsAll[i]}
    //     radius={0.5}
    //     color={'white'}
    //   />
    //   );
    //   key += 1;
    // }



    // innerSurface: merge lower and upper warp points
    var divInnerWarpPointsAll = mergeLowerUpperPoints(innerLowerWarpPointsAll, innerUpperWarpPointsAll, div);

    const firstFilletPoints = [];
    const lastFilletPoints = [];
    const refFilletPoints = [];
    const lastIdxs = [];

    //delete points for fillet, points are deleted if the distance from the boundary between lower and upper surface is less than radius
    for (let i = 0; i < divInnerWarpPointsAll.length; i++) {
      var step = 0;
      var cnt = 0
      var tempIdx = 0;
      var tempPoint = null;
      const oriLength = divInnerWarpPointsAll[i].length;
      const refPoint = findClosestPointOnPoints(divInnerWarpPointsAll[i], innerUpperWarpPointsAll[i][0]);
      refFilletPoints.push(refPoint.point);

      // delete points for fillet
      divInnerWarpPointsAll[i] = divInnerWarpPointsAll[i].filter((vector, index, array) => {
        // retain the first and last elements of the array
        if (index === 0 || index === array.length - 1) {
          return true; // retain the first and last elements of the array
        }
        // calc distance between vector and refPoint
        const distance = vector.distanceTo(refPoint.point);
        // delete points if the distance is less than radius
        if (distance < radiusIschium) {
          if (step == 0) {
            firstFilletPoints.push(vector);
            step += 1;
          }
          tempPoint = vector;
          tempIdx = index;

          return false;
        }
        return true;
      });
      lastFilletPoints.push(tempPoint);
      lastIdxs.push(oriLength - tempIdx);
    };
    
    // judge fillet or not by y coordinate of last point
    var filletIndex = [];
    var minY = 10000;
    var maxY = -10000;
    // find minY and maxY of upper edge
    for (let i=0; i<divInnerWarpPointsAll.length; i++) {
      var point = divInnerWarpPointsAll[i][divInnerWarpPointsAll[i].length-1];
      if (point.y < minY) minY = point.y;
      if (point.y > maxY) maxY = point.y;
    }

    // find index of fillet around anterior and interior wall
    for (let i=0; i<divInnerWarpPointsAll.length; i++) {
      var point = divInnerWarpPointsAll[i][divInnerWarpPointsAll[i].length-1];
      if (point.y < minY + 0.5*(maxY-minY)) {
        filletIndex.push(i);
      }
    }

    // set radius from const radiusIschium or min distance from firstFilletPoints, lastFillerPoints and refFilletPoints
    const radiusIschiums = [];
    for (let i=0; i<firstFilletPoints.length; i++) {
      if (filletIndex.includes(i) == false) {
        radiusIschiums.push(0);
        continue;
      }
      // find min distance from firstFilletPoints, lastFillerPoints and refFilletPoints
      const distanceFirst = firstFilletPoints[i].distanceTo(refFilletPoints[i]);
      const distanceLast = lastFilletPoints[i].distanceTo(refFilletPoints[i]);
      const distanceMin = Math.min(distanceFirst, distanceLast);
      radiusIschiums.push(distanceMin);
    }

    
    // smooth radiusIschiums as moving average
    // Compute moving average
    const n = 5; // number of points to consider for moving average
    const movingAverageRadiusIschiums = radiusIschiums.map((val, idx, arr) => {
      if (val == 0) return 0;
      let values = [];
      for (let i = 0; i < n; i++) {
          let index = (idx - i + arr.length) % arr.length; // Use modulo to cycle through array
          values.push(arr[index]);
      }
      let sum = values.reduce((a, b) => a + b, 0);
      return sum / values.length;
    });

    // if movingAverageRadiusIschiums have 0 as next value, divide 2 to movingAverageRadiusIschiums
    for (let i=0; i<movingAverageRadiusIschiums.length-1; i++) {
      if (movingAverageRadiusIschiums[i+1] == 0) {
        movingAverageRadiusIschiums[i] /= 2;
      }
    }

    // add fillet points
    const filletPoints = [];
    const centerPoints = [];
    for (let i=0; i<firstFilletPoints.length; i++) {
      if ( movingAverageRadiusIschiums[i] == 0) continue;
      // vaclcate two vectors from firstFilletPoints, lastFillerPoints and refFilletPoints
      const vector0 =  new THREE.Vector3().subVectors(firstFilletPoints[i], refFilletPoints[i]).normalize();
      const vector1 =  new THREE.Vector3().subVectors(lastFilletPoints[i], refFilletPoints[i]).normalize();
      // bisector of two vectors
      const bisector = new THREE.Vector3().addVectors(vector0, vector1).normalize();
      // center of fillet
      let center = null;
      const center0 = new THREE.Vector3().addVectors(refFilletPoints[i].clone(), bisector.clone().multiplyScalar(movingAverageRadiusIschiums[i]));
      const center1 = new THREE.Vector3().addVectors(refFilletPoints[i].clone(), bisector.clone().multiplyScalar(-movingAverageRadiusIschiums[i]));
      // choose center0 or center1, which is far from centroidBaseshape
      if (center0.distanceTo(centroidBaseshape) > center1.distanceTo(centroidBaseshape)) {
        center = center0;
      } else {
        center = center1;
      }
 
      // calculate vector between center and refFilletPoints
      const vectorCenter = new THREE.Vector3().subVectors(refFilletPoints[i], center);
      // calculate a point on the fillet from vectorCenter
      const point = new THREE.Vector3().addVectors(center, vectorCenter.normalize().multiplyScalar(movingAverageRadiusIschiums[i]*0.5));

      // insert point
      divInnerWarpPointsAll[i].splice(divInnerWarpPointsAll[i].length-lastIdxs[i]+1, 0, point);

      centerPoints.push(center);
      filletPoints.push([point]);
    }

    // // show centerPoints
    // for (let i=0; i<centerPoints.length; i++) {
    //   objectsSub.push(<Point
    //     key={key}
    //     vpoint={centerPoints[i]}
    //     color={'red'}
    //     size={1}
    //   />
    //   );
    //   key += 1;
    // }

    // for (let i=0; i<firstFilletPoints.length; i++) {
    //   objectsSub.push(<Point
    //     key={key}
    //     vpoint={firstFilletPoints[i]}
    //     color={'blue'}
    //     size={1}
    //   />
    //   );
    //   key += 1;
    // }

    // for (let i=0; i<lastFilletPoints.length; i++) {
    //   objectsSub.push(<Point
    //     key={key}
    //     vpoint={lastFilletPoints[i]}
    //     color={'green'}
    //     size={1}
    //   />
    //   );
    //   key += 1;
    // }

    // // show filletPoints
    // for (let i=0; i<refFilletPoints.length; i++) {
    //   objectsSub.push(<Point
    //     key={key}
    //     vpoint={refFilletPoints[i]}
    //     color={'yellow'}
    //     size={1}
    //   />
    //   );
    //   key += 1;
    // }

    // for (let i=0; i<filletPoints.length; i++) {
    //   for (let j=0; j<filletPoints[i].length; j++) {
    //     objectsSub.push(<Point
    //       key={key}
    //       vpoint={filletPoints[i][j]}
    //       color={colorHigh}
    //       size={1}
    //     />
    //     );
    //     key += 1;
    //   }
    // }

    // for (let i=0; i<divInnerWarpPointsAll.length; i++) {
    //   for (let j=0; j<divInnerWarpPointsAll[i].length; j++) {
    //     objectsSub.push(<Point
          
    //       key={key}
    //       vpoint={divInnerWarpPointsAll[i][j]}
    //       color={colorHigh}
    //       size={1}
    //     />
    //     );
    //     key += 1;
    //   }

    //   objectsSub.push(<TubeCurve
    //     key={key}
    //     vpoints={divInnerWarpPointsAll[i]}
    //     radius={0.5}
    //     color={colorHigh}
    //   />
    //   );

    //   key += 1;
    // }


    // reample as div points
    divInnerWarpPointsAll = divInnerWarpPointsAll.map((points) => new THREE.CatmullRomCurve3(points).getSpacedPoints(div));

    if (divInnerWarpPointsAll.length > 0) {
      // for (let i=0; i<divInnerWarpPointsAll.length; i++) {
      //   objectsSub.push(<TubeCurve
      //     key={key}
      //     vpoints={divInnerWarpPointsAll[i]}
      //     radius={0.5}
      //     color={'white'}
      //   />
      //   );
      //   key += 1;
      // }
    }

    // loft whole surface ///////////////////////////////////////////
    var divInnerWeftPointsAll = [];
    for (let i = 0; i < div+1; i++) {
      var divInnerWeftPoints = divInnerWarpPointsAll.map((points) => points[i]);
      divInnerWeftPoints = new THREE.CatmullRomCurve3(divInnerWeftPoints).getSpacedPoints(segmentsWidth);
      divInnerWeftPointsAll.push(divInnerWeftPoints);
    }
    
    divInnerWeftPointsAll = divInnerWeftPointsAll.map((points) => {
      points = new THREE.CatmullRomCurve3(points, true).getSpacedPoints(segmentsWidth*2/3); // smoothing
      points = new THREE.CatmullRomCurve3(points, true).getSpacedPoints(segmentsWidth);
      return makeCurveClockwise(points);
    });

    // add rotation angle to inner weft points
    divInnerWeftPointsAll = divInnerWeftPointsAll.map((points) => {
      for (let i=0; i<points.length; i++) {
        points[i] = points[i].sub(rotationCenter);
        points[i].applyAxisAngle(new THREE.Vector3(1,0,0), -Math.PI*assembleFlexionExtension/180); // extension/flexion
        points[i].applyAxisAngle(new THREE.Vector3(0,0,1), Math.PI*assembleAdductionAbduction/180); // abduction/adduction
        points[i].applyAxisAngle(new THREE.Vector3(0,1,0), Math.PI*assembleSocketRotation/180); // external/internal rotation
        points[i] = points[i].add(rotationCenter);
      }
      return points;
    });

    // show divInnerWeftPointsAll
    for (let i=0; i<divInnerWeftPointsAll.length; i++) {
      objectsSub2.push(<Points
        key={key}
        vpoints={divInnerWeftPointsAll[i]}
        radius={0.3}
        color={colorSub}
      />
      );
      key += 1;
    }

    // loft inner surface
    const seamPoint = [new THREE.Vector3(0,0,0)]
    var topInnerPoints = [];
    var bottomDivInnerPoints = [];
    var topDivInnerPoints = [];
    var loftPointsAll = [];

    for (let i = 0; i < divInnerWeftPointsAll.length-1; i++) {
      if (i == 0) {
        var loftPoints0 = divInnerWeftPointsAll[i];
        var loftPoints1 = alignSeamPoints(loftPoints0, divInnerWeftPointsAll[i+1]);
        loftPointsAll.push(loftPoints0);
        loftPointsAll.push(loftPoints1);
      } else {
        var loftPoints0 = loftPoints1;
        var loftPoints1 = alignSeamPoints(loftPoints0, divInnerWeftPointsAll[i+1]);
        loftPointsAll.push(loftPoints1);
      }

      if (i == divInnerWeftPointsAll.length-2) {
        topInnerPoints = loftPoints1;
      }
    }

    ///*
    var loftSurface = createLoftSurfaceFromCurves(loftPointsAll, segmentsWidth, segmentsHeight, colorSub, true);

    innerSurfaceMesh = new THREE.Mesh( loftSurface.geometry, materialInner ) ;
    objectsInner.push(
      <primitive key={key} object={innerSurfaceMesh} />
    );
    key += 1;
    
    // Obtain the vertex coordinates of the top and bottom edges
    var loftPosition = loftSurface.geometry.attributes.position.array;
    var upperEdgeVertices = [];
    var lowerEdgeVertices = [];
    for (let j = 0; j < loftPosition.length; j+=3) {
      if (j < 3*(segmentsWidth+1)) {
        lowerEdgeVertices.push(new THREE.Vector3(loftPosition[j], loftPosition[j+1], loftPosition[j+2]));
      } else if (j >= 3*(segmentsWidth+1)*(segmentsHeight)) {
        upperEdgeVertices.push(new THREE.Vector3(loftPosition[j], loftPosition[j+1], loftPosition[j+2]));
      }
    }
    bottomDivInnerPoints = lowerEdgeVertices;
    topDivInnerPoints = upperEdgeVertices;
    //*/

    var innerSurface = null
    var innerSurfaceMesh = null
    if (objectsInner.length!==0) {
      var geomObject = objectsInner.map((obj) => {
        return obj.props.object.geometry;
      })
      innerSurface = BufferGeometryUtils.mergeGeometries(geomObject);
      innerSurface = BufferGeometryUtils.mergeVertices(innerSurface);
    }


    // bottom cap for inner surface
    //var innerBottomCurve = new THREE.CatmullRomCurve3(divInnerWeftPointsAll[0], true);
    var innerBottomCurve = new THREE.CatmullRomCurve3(divInnerWeftPointsAll[0], false);
    var innerBottomPoints = innerBottomCurve.getPoints(segmentsWidth);
    innerBottomPoints = innerBottomPoints.map(vector => vector.clone());
    innerBottomPoints = innerBottomPoints.reverse();

    // get center point of bottom cap
    const centerInnerBottomPoints = new THREE.Vector3();
    innerBottomPoints.forEach((vector) => {
      centerInnerBottomPoints.add(vector);
    });
    centerInnerBottomPoints.divideScalar(innerBottomPoints.length);

    // get original vertices and update it
    const oldVertices = innerSurface.attributes.position.array;
    const newVertices = [...oldVertices, centerInnerBottomPoints.x, centerInnerBottomPoints.y, centerInnerBottomPoints.z];

    const newAttribute = new THREE.Float32BufferAttribute(newVertices, 3);
    innerSurface.setAttribute('position', newAttribute);
    
    // get original faces and update it
    const oldFaces = innerSurface.index.array;
    const newFaces = [...oldFaces];

    const lastVertexIndex = innerSurface.attributes.position.count - 1;

    for (let i = 2; i < 2*segmentsWidth-1; i+=2) {
      if (i == 2) {
        newFaces.push(4, 1, lastVertexIndex); // first face, there are some shift.
      } else {
        newFaces.push(i+2, i, lastVertexIndex);
      }
    }
    newFaces.push(1, 2*segmentsWidth, lastVertexIndex); // last face

    innerSurface.setIndex(newFaces);
    innerSurface.computeVertexNormals();


    if (innerSurface!==null) {
      innerSurfaceMesh = new THREE.Mesh( innerSurface, materialInner ) ;
      objects.push(
        <primitive key={key} object={innerSurfaceMesh} />
      );
      key += 1;
    }


    // const bottomCapInner = createBottmCapSurface(innerBottomPoints)
    // const bottomCapInnerMesh = new THREE.Mesh(bottomCapInner, materialInner);

    // objects.push(
    //   <primitive key={key} object={bottomCapInnerMesh} />
    // );
    // key += 1;
    ///////////////////////////////////////////////////////////////////////////

    if (divInnerWeftPointsAll.length > 0) {
      for (let i=0; i<divInnerWeftPointsAll.length; i++) {
        objectsSub.push(<TubeCurve
          key={key}
          vpoints={divInnerWeftPointsAll[i]}
          radius={0.5}
          color={colorSub}
        />
        );
        key += 1;
      }
    }


    
    // cross sections of inner lowwer surface for outer parametric surface //////////////////////////////////
    const nCross = Math.floor((stumpLength-crossInterval-splitHeight+splitAdjust) / crossInterval);
    
    const offsets = [];
    for (let i=0; i<nCross; i++) {
      //offsets.push(-stumpLength + i*50);
      offsets.push(-stumpLength+i*crossInterval);
    }

    // Get cross section of inner surface and offset it to use it for weft curves for outer surface
    const contourPointsAll = [];
    for (let i=0; i<offsets.length; i++) {
      var offset = offsets[i];
      var plane = new THREE.Plane(new THREE.Vector3(0,1,0), -offset);
      var vertices = drawIntersectionPoints(innerSurfaceMesh, plane, offset, false);

      if (vertices.length == 0) {
        contourPointsAll.push([]);
        continue;
      }

      var contourPoints = sortPoints(vertices);

      contourPoints.push(contourPoints[0]);
      // var contourCurve = new THREE.CatmullRomCurve3(contourPoints);
      // contourPoints = offsetCurveMm(contourCurve, socketThickness);
      contourPoints = offsetPointsNormalBufferGeometry(loftSurface.geometry, contourPoints, -socketThickness);
      // var tempCurve = new THREE.CatmullRomCurve3(contourPoints);
      // contourPoints = tempCurve.getSpacedPoints(20);

      // removeOutliers
      const threshold = 1.0;  // threshold
      const filteredContourPoints = removeOutliersThreePoints(contourPoints, threshold);

      contourPointsAll.push(filteredContourPoints);

      // objectsSub.push(<TubeCurve 
      //   key={key} 
      //   vpoints={filteredContourPoints} 
      //   radius={0.5}
      //   color={'white'}
      //   />
      // );
      // key += 1;

      // show point
      // for (let i=0; i<filteredContourPoints.length; i++) {
      //   objectsSub.push(<Point
      //     key={key}
      //     vpoint={filteredContourPoints[i]}
      //     color={colorHigh}
      //     size={1}
      //   />
      //   );
      //   key += 1;
      // }
    }

    // get linear curve for outer bottom surface
    const linearPoints0 = calculateIntersectionPoints(new THREE.CatmullRomCurve3(bottomPoints, true), angleStep, close=false);
    const linearPoints1 = calculateIntersectionPoints(new THREE.CatmullRomCurve3(contourPointsAll[contourPointsAll.length-1], true), angleStep, close=false);
    const linearCurves = [];
    const linearCrossWarpPoints = [];
    const linearCrossWeftPoints = [];
    const curveHeight = contourPointsAll[contourPointsAll.length-1][0].y - bottomPoints[0].y;
    for (let i=0; i<linearPoints0.length; i++) {
      const temp = [];
      linearCurves.push(new THREE.LineCurve3(linearPoints0[i], linearPoints1[i]));
      for (let j=0; j<offsets.length; j++) {
        const offset = offsets[j] - bottomPoints[0].y;
        temp.push(linearCurves[i].getPoint(offset/curveHeight))
      }
      linearCrossWarpPoints.push(temp);
    }
    for (let i = 0; i < 360/angleStep; i++) {
      const temp = linearCrossWarpPoints.map((points) => points[i]);
      linearCrossWeftPoints.push(temp);
    }

    ///*
    // Patch cross sections and rectangle ///////////////////////////////////////////////
    const patchPointsAll = [];
    // set tween factros
    const ts = [];
    for (let i=0; i<offsets.length; i++) {
      if (type=='TestSocket') {
        //ts.push(1);
        ts.push(1-0.5/offsets.length*i); // minimum tween factor is 0.3
      } else if (type=='FinalDevice') {
        ts.push(1-0.5/offsets.length*i); // minimum tween factor is 0.3
        //ts.push(1)
      }
    }

    for (let i=1; i<offsets.length; i++) {
      var t = ts[i]
      var rectanglePoints = bottomPoints.map((point) => {
        return new THREE.Vector3(point.x, offsets[i], point.z)
      });
      var contourPoints = contourPointsAll[i]

      rectanglePoints = offsetCurve(new THREE.CatmullRomCurve3(rectanglePoints, true), 1.2);
      contourPoints = offsetCurve(new THREE.CatmullRomCurve3(contourPoints, true), 1.02);
      // tween curve with bottom rectangle curve and contour curve
      const tweenCurvePoints1 = calculateIntersectionPoints(new THREE.CatmullRomCurve3(rectanglePoints, true), angleStep, close=false);
      const tweenCurvePoints2 = calculateIntersectionPoints(new THREE.CatmullRomCurve3(contourPoints, true), angleStep, close=false);
      rectanglePoints = calculateTweenCurve(tweenCurvePoints1, tweenCurvePoints2, t); // tween curve
      rectanglePoints = rectanglePoints.map((point) => {
        return new THREE.Vector3(point.x, offsets[i], point.z)
      });

      // patch two curve for second and third bottom curve
      const intersectionPoints1 = calculateIntersectionPoints(new THREE.CatmullRomCurve3(rectanglePoints, true), angleStep, close=false);
      const intersectionPoints2 = tweenCurvePoints2;
      //const intersectionPoints3 = calculateIntersectionPoints(new THREE.CatmullRomCurve3(linearCrossWeftPoints[i], true), angleStep, close=false);
      const tempPatchPoints = intersectionPoints1.concat(intersectionPoints2);
      const patchCenter = calcCentroid(tempPatchPoints);
      
      var patchPoints = [];
      for (let i=0; i<intersectionPoints1.length; i++) {
        const dist1 = intersectionPoints1[i].distanceTo(patchCenter);
        const dist2 = intersectionPoints2[i].distanceTo(patchCenter);
        const dist = [dist1, dist2];
        //const dist3 = intersectionPoints3[i].distanceTo(patchCenter);
        //const dist = [dist1, dist2, dist3];
        
        if (dist.indexOf(Math.max(...dist)) == 0) {
          patchPoints.push(intersectionPoints1[i]);
        } else if (dist.indexOf(Math.max(...dist)) == 1) {
          patchPoints.push(intersectionPoints2[i]);
        }
          // } else if (dist.indexOf(Math.max(...dist)) == 2) {
        //   patchPoints.push(intersectionPoints3[i]);
        // }
      }

      patchPoints.push(patchPoints[0]); // close curve
      //patchPoints = new THREE.CatmullRomCurve3(patchPoints).getPoints(15);
      patchPointsAll.push(patchPoints);

      if (patchPoints.length > 0) {
        objectsSub.splice(i+1,0,
        <TubeCurve 
          key={key} 
          vpoints={patchPoints} 
          radius={0.5}
          color={colorHigh}
          />
        );
        key += 1;
      }
    }

    
    // top offset surface ///////////////////////////////////////////////
    // offset edge points
    var offsetUpperEdgePoints = divInnerWeftPointsAll[divInnerWeftPointsAll.length-1].map(vector => vector.clone());
    // offset upper edge ///////////////////////////////////////////////
    offsetUpperEdgePoints = offsetPointsNormalBufferGeometry(loftSurface.geometry, offsetUpperEdgePoints, -socketThickness);
    var tempCurve = new THREE.CatmullRomCurve3(offsetUpperEdgePoints);
    offsetUpperEdgePoints = tempCurve.getPoints(20);
    
    if (offsetUpperEdgePoints.length > 0) {
      // objectsSub.push(<TubeCurve 
      //   key={key} 
      //   vpoints={offsetUpperEdgePoints} 
      //   radius={0.5}
      //   color={colorHigh}
      //   />
      // );
      // key += 1;
    }

    
    // // loft top surface
    // var divTopWeftPointsAll = [];
    // divTopWeftPointsAll.push(divInnerWeftPointsAll[divInnerWeftPointsAll.length-1]);
    // divTopWeftPointsAll.push(offsetUpperEdgePoints);

    // divTopWeftPointsAll = divTopWeftPointsAll.map((points) => {
    //   return makeCurveClockwise(points);
    // });

    // var offsetTopPoints = [];
    // for (let i = 0; i < divTopWeftPointsAll.length-1; i++) {
    //   var loftPoints0 = divTopWeftPointsAll[i];
    //   var loftPoints1 = alignSeamPoints(loftPoints0, divTopWeftPointsAll[i+1]);
    //   var loftCurve0 = new THREE.CatmullRomCurve3(loftPoints0, true);
    //   var loftCurve1 = new THREE.CatmullRomCurve3(loftPoints1, true);

    //   var loftSurface = createLoftSurfaceFrom2Curves(loftCurve0, loftCurve1, segmentsWidth, segmentsHeight, color);

    //   // 上縁と下縁の頂点座標を取得
    //   if (i == 0) {
    //     var loftPosition = loftSurface.geometry.attributes.position.array;
    //     var upperEdgeVertices = [];
    //     var lowerEdgeVertices = [];
    //     for (let j = 0; j < loftPosition.length; j+=3) {
    //       if (j < 3*(segmentsWidth+1)) {
    //         lowerEdgeVertices.push(new THREE.Vector3(loftPosition[j], loftPosition[j+1], loftPosition[j+2]));
    //       } else if (j > 3*(segmentsWidth+1)*(segmentsHeight-1)) {
    //         upperEdgeVertices.push(new THREE.Vector3(loftPosition[j], loftPosition[j+1], loftPosition[j+2]));
    //       }
    //     }
    //     offsetTopPoints = upperEdgeVertices;
    //   }

    //   objects.push(
    //     <primitive key={key} object={loftSurface} />
    //   );
    //   key += 1;
    // }


    
    // Outer surface ///////////////////////////////////////////////
    // make outer surface
    var divOuterWeftPointsAll = [];
    var divOuterReinforceWeftPointsAll = []; // for reinforce ischium
    // bottom part
    divOuterWeftPointsAll.push(new THREE.CatmullRomCurve3(bottomPoints).getPoints(segmentsWidth)); 
    // middle part
    for (let i=0; i<patchPointsAll.length; i++) {
      divOuterWeftPointsAll.push(new THREE.CatmullRomCurve3(patchPointsAll[i]).getPoints(segmentsWidth));
    }
    for (let i=0; i<divInnerWeftPointsAll.length-1; i++) {
      var tempPoints = divInnerWeftPointsAll[i].map(vector => vector.clone());
      var center = calcCentroid(tempPoints);

      if (center.y < -splitHeight + splitAdjust) {
        continue
      }

      if (center.y > -45) { // -45 is split line height
        divOuterReinforceWeftPointsAll.push(offsetPointsNormalBufferGeometry(innerSurface, tempPoints, -socketThickness));
      } else {
        divOuterWeftPointsAll.push(offsetPointsNormalBufferGeometry(innerSurface, tempPoints, -socketThickness));
      }
    }
    // top part
    divOuterWeftPointsAll.push(new THREE.CatmullRomCurve3(offsetUpperEdgePoints).getPoints(segmentsWidth));
    
    if (divOuterWeftPointsAll.length > 0) {
      for (let i=0; i<divOuterWeftPointsAll.length; i++) {
        objectsSub.push(<TubeCurve
          key={key}
          vpoints={divOuterWeftPointsAll[i]}
          radius={0.5}
          color={colorHigh}
        />
        );
        key += 1;
      }
    }

    // judge which line will be replaces as straight line
    var straightLineIndex = [];
    var minY = 10000;
    var maxY = -10000;
    //// get minY and maxY of upper edge
    for (let i=0; i<divOuterWeftPointsAll[divOuterWeftPointsAll.length-1].length; i++) {
      var point = divOuterWeftPointsAll[divOuterWeftPointsAll.length-1][i];
      if (point.y < minY) {
        minY = point.y;
      }
      if (point.y > maxY) {
        maxY = point.y;
      }
    }
    //// find index of fillet around anterior and interior wall
    for (let i=0; i<divOuterWeftPointsAll[divOuterWeftPointsAll.length-1].length; i++) {
      var point = divOuterWeftPointsAll[divOuterWeftPointsAll.length-1][i];
      if ( type=='TestSocket' ) {
        if (point.y < 0.4*(minY + maxY)) { // TODO: 0.4 is threshold, but optimally shuold decide automatically
          if (point.z < -apDiameter/4) { // minimum reinforcement only for interior-posterior wall
            straightLineIndex.push(i);
          }
        }
      } else if ( type=='FinalDevice' ) {
        if (point.y < 0.6*(minY + maxY)) {
          straightLineIndex.push(i);
        }
      }
    }

    // make straght line for reinforce ischium
    const firstPointsLine = divOuterWeftPointsAll[divOuterWeftPointsAll.length-2];
    const secondPointsLine = divOuterWeftPointsAll[divOuterWeftPointsAll.length-1];
    const straightLinePoints = [];
    for (let i=0; i<firstPointsLine.length; i++) {
      straightLinePoints.push([firstPointsLine[i], secondPointsLine[i]]);
    }

    if (straightLinePoints.length > 0) {
      for (let i=0; i<straightLinePoints.length; i++) {
        if (straightLineIndex.includes(i) == false) {
          continue
        }
        // objectsSub.push(<TubeCurve
        //   key={key}
        //   vpoints={straightLinePoints[i]}
        //   radius={0.5}
        //   color={colorHigh}
        // />
        // );
        // key += 1;
      }
    }

    // replace curve as straight line
    const nDivOuterReinforceWeftPointsAll = divOuterReinforceWeftPointsAll.length;
    const nStraightLine = straightLineIndex.length;
    
    for (let i=0; i<nDivOuterReinforceWeftPointsAll; i++) {
      for (let j=0; j<nStraightLine; j++) {
        var index = straightLineIndex[j];
        var straightLinePointsStart = null;
        var ratio = j / (nStraightLine/3);
        var p0 = null;

        if ( type=='TestSocket' ) {
          // smooth connect reinforcement curve
          if (j < nStraightLine/3) {
            straightLinePointsStart = straightLinePoints[index][0];
            if (i < (nDivOuterReinforceWeftPointsAll-1)*(1-ratio)) {
              continue
            }
          } else {
            straightLinePointsStart = straightLinePoints[index][0];
          }
          p0 = straightLinePointsStart;
        } else if ( type=='FinalDevice' ) {
          p0 = straightLinePoints[index][0];
        }
                  
        var p1 = straightLinePoints[index][1];

        var point = divOuterReinforceWeftPointsAll[i][index]; // to be replaced as straight line point
        var yPlane = point.y;
        var t = (yPlane - p0.y) / (p1.y - p0.y);
        //var t = i / nDivOuterReinforceWeftPointsAll;

        var xIntersection = p0.x + t * (p1.x - p0.x);
        var zIntersection = p0.z + t * (p1.z - p0.z);

        if ( type=='TestSocket' ) {
          if (j < nStraightLine/3) {
            //var yIntersection = ((1-ratio)*yPlane + (ratio)*(p0.y + t * (p1.y - p0.y))) / 2;
            var yIntersection = (yPlane + (p0.y + t * (p1.y - p0.y))) / 2;
            //var yIntersection = p0.y + t * (p1.y - p0.y);
          } else {
            var yIntersection = p0.y + t * (p1.y - p0.y);
          }
          const intersection = new THREE.Vector3(xIntersection, yIntersection, zIntersection);
          divOuterReinforceWeftPointsAll[i][index] = intersection;
        } else if ( type=='FinalDevice' ) {
          const intersection = new THREE.Vector3(xIntersection, yPlane, zIntersection);
          divOuterReinforceWeftPointsAll[i][index] = intersection;
        }
      }

      divOuterReinforceWeftPointsAll[i] = new THREE.CatmullRomCurve3(divOuterReinforceWeftPointsAll[i], true).getSpacedPoints(segmentsWidth*2/3);
      
      // divOuterReinforceWeftPointsAll[i] = divOuterReinforceWeftPointsAll[i].map((point, index) => {
      //   const nPoints = divOuterReinforceWeftPointsAll[i].length;
      //   const prevPoint = divOuterReinforceWeftPointsAll[i][(index - 1 + nPoints) % nPoints];
      //   const nextPoint = divOuterReinforceWeftPointsAll[i][(index + 1) % nPoints];
        
      //   const a = new THREE.Vector3().subVectors(prevPoint, point).normalize();
      //   const b = new THREE.Vector3().subVectors(nextPoint, point).normalize();
        
      //   const curvature = a.angleTo(b);  // 曲率の計算 (角度で)

      //   console.log(curvature)
      
      //   // if (curvature > YOUR_THRESHOLD) {  // 閾値より大きい場合
      //   //   return new THREE.Vector3().addVectors(prevPoint, nextPoint).multiplyScalar(0.5);  // 前後の点の平均に置き換える
      //   // } else {
      //   //   return point;  // 曲率が閾値以下の場合はそのまま返す
      //   // }
      // });
      
      
      
      divOuterReinforceWeftPointsAll[i] = new THREE.CatmullRomCurve3(divOuterReinforceWeftPointsAll[i], true).getSpacedPoints(segmentsWidth);

      objectsSub.push(<TubeCurve
        key={key}
        vpoints={divOuterReinforceWeftPointsAll[i]}
        radius={0.5}
        color={colorHigh}
      />
      );
      key += 1;
    }

    // add reinforce ischium curve to divOuterWeftPointsAll
    divOuterWeftPointsAll.splice(divOuterWeftPointsAll.length-1, 0, ...divOuterReinforceWeftPointsAll);

    
    // loft outer surface
    var bottomOuterPoints = [];
    var topOuterPoints = [];
    var topDivOuterPoints = [];
    var loftOuterPointsAll = [];

    
    // flip normals
    for (let i=0; i<divOuterWeftPointsAll.length; i++) {
      divOuterWeftPointsAll[i].reverse();
    }

    for (let i = 0; i < divOuterWeftPointsAll.length-1; i++) {
      if (i == 0) {
        var loftPoints0 = divOuterWeftPointsAll[i];
        var loftPoints1 = divOuterWeftPointsAll[i+1]; //alignSeamPoints(loftPoints0, divOuterWeftPointsAll[i+1]);
        loftOuterPointsAll.push(loftPoints0);
        loftOuterPointsAll.push(loftPoints1);
        
      } else {
        var loftPoints0 = loftPoints1;
        var loftPoints1 = alignSeamPoints(loftPoints0, divOuterWeftPointsAll[i+1]);
        loftOuterPointsAll.push(loftPoints1);
      }
    }

    let divOuterWarpPointsAll = [];
    for (let i = 0; i < divOuterWeftPointsAll[0].length; i++) {
      var divOuterWarpPoints = [];
      for (let j = 0; j < divOuterWeftPointsAll.length; j++) {
        divOuterWarpPoints.push(divOuterWeftPointsAll[j][i]);
      };
      divOuterWarpPointsAll.push(divOuterWarpPoints);
    }

    // show divOuterWarpPointsAll tubecurve
    for (let i=0; i<divOuterWarpPointsAll.length; i++) {
      objectsSub.push(<TubeCurve
        key={key}
        vpoints={divOuterWarpPointsAll[i]}
        radius={0.5}
        color={colorHigh}
      />
      );
      key += 1;
    }
    

    ///*
    var loftSurface = createLoftSurfaceFromCurves(loftOuterPointsAll, segmentsWidth, segmentsHeight, color, true);

    // 上縁と下縁の頂点座標を取得
    var loftPosition = loftSurface.geometry.attributes.position.array;

    var upperEdgeVertices = [];
    var lowerEdgeVertices = [];
    for (let j = 0; j < loftPosition.length; j+=3) {
      if (j < 3*(segmentsWidth+1)) {
        lowerEdgeVertices.push(new THREE.Vector3(loftPosition[j], loftPosition[j+1], loftPosition[j+2]));
      } else if (j >= 3*(segmentsWidth+1)*(segmentsHeight)) {
        upperEdgeVertices.push(new THREE.Vector3(loftPosition[j], loftPosition[j+1], loftPosition[j+2]));
      }
    }

    bottomOuterPoints = lowerEdgeVertices;
    topDivOuterPoints = upperEdgeVertices;
    topOuterPoints = loftOuterPointsAll[loftOuterPointsAll.length-1]


    // reinforce top edge of outer surface
    var position = loftSurface.geometry.attributes.position;
    var normal = loftSurface.geometry.attributes.normal;
    const maxX = topDivOuterPoints.map(p => p.x).reduce((a,b) => Math.max(a,b));

    for (let i = 0; i < position.count; i++) {
      if (i >= (segmentsWidth+1)*(segmentsHeight)) continue // top edge

      let vertex = new THREE.Vector3(position.array[i*3], position.array[i*3+1], position.array[i*3+2]);
      let normalVector = new THREE.Vector3(normal.array[i*3], normal.array[i*3+1], normal.array[i*3+2]);
    
      if (vertex.y < -50) continue

      let minDistance = Infinity;
      for (let curvePoint of topDivOuterPoints) {
        let distance = vertex.distanceTo(curvePoint);
        if (distance < minDistance) {
          minDistance = distance;
        }
      }

      if (minDistance <= reinforceEdgeWidth) {
        var offset = reinforceEdgeHeight * (vertex.x/maxX)
        if (offset < 0) offset = 0;
        offset = offset * (1 - minDistance/reinforceEdgeWidth);

        //var distOri = vertex.distanceTo(centroidBaseshape);
        
        vertex.add(normalVector.multiplyScalar(offset));

        // flip direction if it is revsered
        // var distNew = vertex.distanceTo(centroidBaseshape);
        // if (distNew < distOri) {
        //   vertex.add(-2*normalVector.multiplyScalar(offset));
        // }

        position.array[i*3] = vertex.x;
        position.array[i*3+1] = vertex.y;
        position.array[i*3+2] = vertex.z;
      }
    }

    loftSurface.geometry.attributes.position.needsUpdate = true;

    objects.push(
      <primitive key={key} object={loftSurface} />
    );
    key += 1;
    //*/

    //////////////////////////////////////////////////////////
    
    // bottom cap for outer surface ////////////////////////////////
    bottomOuterPoints = bottomOuterPoints.map(vector => vector.clone());
    bottomOuterPoints = bottomOuterPoints.reverse(); // for flip normal
    const bottomCapOuter = createBottmCapSurface(bottomOuterPoints)
    const bottomCapOuterMesh = new THREE.Mesh(bottomCapOuter, material);

    objects.push(
      <primitive key={key} object={bottomCapOuterMesh} />
    );
    key += 1;
    //////////////////////////////////////////////////////////


    
    // loft top surface
    var divTopWeftPointsAll = [];
    var stackTop = 2;
    //divTopWeftPointsAll.push(divInnerWeftPointsAll[divInnerWeftPointsAll.length-1]);
    divTopWeftPointsAll.push(topInnerPoints);
    divTopWeftPointsAll.push(topOuterPoints);

    divTopWeftPointsAll = divTopWeftPointsAll.map((points) => {
      return makeCurveClockwise(points);
    });

    var loftPoints0 = divTopWeftPointsAll[0];
    var loftPoints1 = alignSeamPoints(loftPoints0, divTopWeftPointsAll[1]);
    //var loftPoints1 = divTopWeftPointsAll[1];

    var loftCurve0 = new THREE.CatmullRomCurve3(loftPoints0, true);
    var loftCurve1 = new THREE.CatmullRomCurve3(loftPoints1, true);

    //console.log(loftCurve0.getPoints(segmentsWidth))
    //console.log(loftCurve1.getPoints(segmentsWidth))

    var loftSurface = createLoftSurfaceFrom2Curves(loftCurve0, loftCurve1, segmentsWidth, stackTop, color);
    
    // 上縁と下縁の頂点座標を取得
    var loftPosition = loftSurface.geometry.attributes.position.array;
    const oldIndices = Array.from(loftSurface.geometry.getIndex().array); // need to be as normal array
    // https://discourse.threejs.org/t/buffergeometry-not-working/27976/4
    //const newIndices = [152, 51, 102]
    const newIndices = [div*3+2, div+1, div*2+2]
    const updatedIndices = [...oldIndices, ...newIndices];
    loftSurface.geometry.setIndex(updatedIndices);     

    topDivOuterPoints = alignSeamPoints(loftPoints0, topDivOuterPoints).reverse();

    var cnt = 0
    var cnt2 = 0
    for (let j = 0; j < loftPosition.length; j+=3) {
      if (j < 3*(segmentsWidth+1)) {
        //lowerTopEdgeVertices.push(new THREE.Vector3(loftPosition[j], loftPosition[j+1], loftPosition[j+2]));
        loftPosition[j] = topDivInnerPoints[cnt].x;
        loftPosition[j+1] = topDivInnerPoints[cnt].y;
        loftPosition[j+2] = topDivInnerPoints[cnt].z;
        cnt += 1;
      } else if (j > 3*(segmentsWidth+1)*(stackTop) ) {
        loftPosition[j] = topDivOuterPoints[cnt2].x;
        loftPosition[j+1] = topDivOuterPoints[cnt2].y;
        loftPosition[j+2] = topDivOuterPoints[cnt2].z;
        cnt2 += 1;
      }
    }
    loftSurface.geometry.attributes.position.needsUpdate = true;


    objects.push(
      <primitive key={key} object={loftSurface} />
    );
    key += 1;
    //////////////////////////////////////////////////////////

    // save
    if (stepFlow == 1) {
      if (objects.length!==0) {
        var geomObject = objects.map((obj) => {
          return obj.props.object.geometry;
        })

        // https://discourse.threejs.org/t/how-to-get-smooth-mesh-of-the-obj/41546/4
        //geomObject.deleteAttribute('normal');
        geom = BufferGeometryUtils.mergeGeometries(geomObject);
        geom = BufferGeometryUtils.mergeVertices(geom, 1e-4);
        geom.computeVertexNormals();

        geom = smoothGeom(geom, 2);

        /*
        objects.push(
          <mesh >
            <Geometry computeVertexNormals>
              <Base name="surface" geometry={geom} />
              <Subtraction name="trim" geometry={tearDropGeometry1} />
            </Geometry>
            <meshBasicMaterial color={color} />
          </mesh>
        )
        */

        //var baseMesh = new THREE.Mesh(geom, material);
        // substract checkhole
        // geom = CSG.subtract(baseMesh, checkHoleMesh);
        // geom = CSG.subtract(geom, tearDropMesh1);
        // geom = CSG.subtract(geom, tearDropMesh2);

        const csgEvaluator = new Evaluator();
        const substractions = [];
        if ( type=='TestSocket' ) {
          for (let i=0; i<sideHoleGeometries.length; i++) {
            substractions.push(sideHoleGeometries[i]);
          }
        }
        substractions.push(checkHoleGeometry);
        substractions.push(counterHoleGeometry);
        substractions.push(fourHoleGeometry0);
        substractions.push(fourHoleGeometry1);
        substractions.push(fourHoleGeometry2);
        substractions.push(fourHoleGeometry3);
        substractions.push(outerFourHoleGeometry0);
        substractions.push(outerFourHoleGeometry1);
        substractions.push(outerFourHoleGeometry2);
        substractions.push(outerFourHoleGeometry3);
        if (engraving !== -1) {
          substractions.push(engravingGeometry);
        }

        for (let i = 0; i < substractions.length; i++) {
          const brush0 = new Brush( geom );
          const brush1 = new Brush( substractions[i] );
          const result = csgEvaluator.evaluate( brush0, brush1, SUBTRACTION );
          geom = result.geometry;
        }

        geom = BufferGeometryUtils.mergeGeometries([geom]);
        geom = BufferGeometryUtils.mergeVertices(geom);

        console.log(geom)
        callback(geom);

        // reset objects to show final mesh with holes
        objects.length = 0;
        //objectsSub.length = 0;
        objectsHole.length = 0; // reset objectsHole to show the final mesh only
        // set final mesh object
        const material = new THREE.MeshMatcapMaterial({color: color});
        const mesh = new THREE.Mesh(geom, material);
        objects.push(<primitive key={key} object={mesh} />);
        key += 1;
      }
    }
  } catch (error) {
    console.log(error);
  }

  return (
    (objects.length > 0) ? (
      <group ref={ref} >
        {stepFlow == 1 && objects}
        {stepFlow == 0 && objectsSub}
        {objectsSub2}
        {objectsHole}
      </group>
    ) : null
  )
});

export default MOutputAkFd
